// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__u3a_Q","overflowing":"ReadFullNote_overflowing__1qA0h"};